module.exports = __webpack_public_path__ + "static/img/bg1.a2f1e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestivalActive/light/bg1.png
// module id = P4tS
// module chunks = 1 14